export enum ChainTypes {
  'EVM' = 1,
  'SUI' = 2,
  'SOL' = 3,
  'BTC' = 4,
  'STX' = 5,
  'APT' = 6,
  'TON' = 7,
  'TRON' = 8,
}
export type ChainTypeList = keyof typeof ChainTypes;
export const ChainTypeList = ['EVM', 'SUI', 'SOL', 'BTC', 'STX', 'TON', 'TRON', 'APT'] as const;
